import { CompanyBankAccountsQuery } from '../../../../common/hooks/useCompanyBankAccounts/graphql/companyBankAccounts.gql';
import { Section, SectionItem } from './SectionList/types';
import { BankAndFeeStatementsQuery } from './useFetchBankAndFeeStatements/graphql/BankAndFeeStatements.gql';

export enum StatementTypes {
  BankStatement = 'BANK_STATEMENT',
  FeeStatement = 'FEE_STATEMENT',
}

export type BankStatementEdges =
  BankAndFeeStatementsQuery['viewer']['bankAccountStatements']['edges'];

export type FeeStatement =
  BankAndFeeStatementsQuery['viewer']['company']['feeStatements'][number];

export type BankStatement = BankStatementEdges[0]['node'];

export type BankAccount =
  CompanyBankAccountsQuery['viewer']['company']['bankAccounts'][number];

export type Statement = BankStatement | FeeStatement;

export interface BankStatementSectionItem extends SectionItem {
  sortingDate: string;
  downloadUrl: string;
}

export interface BankStatementsSection extends Section {
  data: BankStatementSectionItem[];
}
